var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatchId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M454.613,0H57.387C25.707,0,0,25.707,0,57.387v397.227C0,486.293,25.707,512,57.387,512h397.227 c31.68,0,57.387-25.707,57.387-57.387V57.387C512,25.707,486.293,0,454.613,0z M490.667,454.613 c0,19.947-16.107,36.053-36.053,36.053H57.387c-19.947,0-36.053-16.107-36.053-36.053V57.387 c0-19.947,16.107-36.053,36.053-36.053h397.227c19.947,0,36.053,16.107,36.053,36.053V454.613z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 148.267,
    width: 26.667,
    height: 211.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.827,138.667h-26.56v87.467h-0.64c-6.613-12.16-20.8-21.227-40.64-21.227c-33.067,0-61.76,29.013-61.76,80.107 c0,47.04,25.493,77.013,59.2,77.013c22.08,0,38.4-12.16,45.653-27.093h0.853l1.6,24.533h23.573 c-0.64-10.027-1.28-25.707-1.28-38.187V138.667z M324.267,298.773c0.107,3.84-0.32,7.573-1.28,11.307 c-5.333,21.013-20.267,31.04-35.413,31.04c-26.56,0-39.893-25.707-39.893-56.747c0-32.32,14.187-58.24,40.533-58.24 c18.347,0,31.68,14.08,35.093,31.04c0.64,3.733,0.96,7.467,0.96,11.307V298.773z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchId);
export default __webpack_public_path__ + "static/media/batch-id.071bb110d579a28eadfa487e86ffa2ab.svg";
export { ForwardRef as ReactComponent };